import messages from './compartir-modal-translations';
import * as $ from 'jquery';
import InstamapsUtils from '../../../../../original/geocatweb/js/instamaps.utils-3.0.0.js';

export default {
    name: 'instamapsCompartirModal',
    i18n: {
        messages,
    },
    data() {
        return {
            url: '',
        };
    },
    computed: {
        urlVisorEmbed: function(){
            return this.mapa.urlVisor + "&embed=1";
        },
        iframe: function(){
            return InstamapsUtils.Dom.createIframeHtml(this.urlVisorEmbed);
        }
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
        mapa: { type: Object },
    },
    methods: {
        show: function () {
           this.url = this.mapa.urlVisor;
           $('#compartir-modal').addClass('animate-flex-modal');
        },
        dismiss: function () {
            $('#compartir-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/compartir-modal/compartir-modal.js